export default "/_next/static/images/90ed82d837edc0529d76d7a566fea442.jpg";